export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    var activeFilters = [];
    function filterDownloads(){

      jQuery('.download-item').each(function(){
        var currentFilters = jQuery(this).attr('data-filter').split(" ");
        var theItem = jQuery(this);
        jQuery(this).addClass('toRemove');

        /* eslint-disable no-console */
        console.log(activeFilters);
        /* eslint-enable no-console */

        jQuery(currentFilters).each(function(i, value){
          if (true === activeFilters[value]){
              jQuery(theItem).removeClass('toRemove');
          }
        });

        /* eslint-disable no-console */
          console.log(activeFilters);
          console.log(currentFilters);
        /* eslint-enable no-console */

      });

      jQuery('.download-item').show();
      jQuery('.toRemove').removeClass('toRemove').fadeOut(500);


    }

    jQuery('.page-sidebar a').click(function(){

      if(jQuery('.page-sidebar li.active').length == jQuery('.page-sidebar li').length) jQuery('.page-sidebar li').removeClass('active');

      jQuery(this).parent().toggleClass('active');



      if(jQuery(this).parent().hasClass('active')){
          activeFilters[jQuery(this).attr('data-filter')] = true;

        /* eslint-disable no-console */
          console.log('true');
        /* eslint-enable no-console */

      }else{
          activeFilters[jQuery(this).attr('data-filter')] = false;
        /* eslint-disable no-console */
          console.log('false');
        /* eslint-enable no-console */
      }

      filterDownloads();
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/downloads.js